// Remembers a page's query string (filters, sort, page size) in
// localStorage so returning to the page without a chosen view restores
// the last-used one. The LiveView pushes "save-params" whenever a chosen
// query changes; the server applies a default view to bare visits (the
// URL then carries auto=true), and this hook offers the saved query back
// over that default through "restore-params".
export default RememberedParams = {
  mounted() {
    const key = this.el.dataset.key;

    this.handleEvent("save-params", ({ query }) => {
      try {
        localStorage.setItem(key, query);
      } catch (_e) {}
    });

    const search = new URLSearchParams(window.location.search);
    if (!window.location.search || search.get("auto") === "true") {
      let saved = null;
      try {
        saved = localStorage.getItem(key);
      } catch (_e) {}
      if (saved) this.pushEvent("restore-params", { query: saved });
    }
  },
};
